export const OPTION_TYPE_NUMBER = "NUMBER";
export const OPTION_TYPE_STRING = "STRING";
export const OPTION_TYPE_WYSIWYG = "WYSIWYG";
export const OPTION_TYPE_CHECKBOX = "CHECKBOX";
export const OPTION_TYPE_OBJECT = "OBJECT";
export const OPTION_TYPE_ARRAY = "ARRAY";
export const OPTION_TYPE_MULTIPLE_OBJECTS = "MULTIPLE_OBJECTS";
